import { ResolveAlert } from '../../types/AlertTypes'

interface IDropDownProps {
  setShowResolveModal: (show: boolean) => void
  resolveAlerts: (alerts: ResolveAlert[]) => void
  alerts: ResolveAlert[]
}

function AlertsResolveModal(props: IDropDownProps) {
  const { setShowResolveModal, resolveAlerts, alerts } = props

  return (
    <div
      className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50"
      onClick={() => setShowResolveModal(false)}
    >
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[50%] overflow-y-auto border dark:border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4">Resolve Alert</h2>
        <p className="mb-4 text-sm text-ErrorRed">
          Please note: resolving alerts with conditional access turned on will allow the associated device access to
          regain access to your organization.
        </p>
        <div className="flex justify-end">
          <button
            className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
            onClick={() => setShowResolveModal(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-mainPurple hover:bg-tertiaryPurple active:active:bg-tertiaryPurple text-white rounded-lg"
            onClick={() => {
              setShowResolveModal(false)
              resolveAlerts(alerts)
            }}
          >
            Resolve
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertsResolveModal
